<template>
<BootstrapDialog title="批量设置考试属性" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <form role="form" class="form-horizontal">
		            <div class="col-sm-12">
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">开考时间</label>
		                        <div class="col-sm-6">
									<DateTimePicker v-model="model.kksj" name="kksj" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:210px" :show-buttons="true" clearable></DateTimePicker>
		                        </div>
		                    </div>
		                </div>
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">结束时间</label>
		                        <div class="col-sm-7">
									<DateTimePicker v-model="model.jssj"  format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:210px" :show-buttons="true" clearable></DateTimePicker>
		                        </div>
		                    </div>
		                </div>
		
		                <div class="col-sm-2">
		                    <button class="btn " type="button" @click="changeflag()"
		                            style="float: right;background-color:#3c8dbc;color: white">
		                        {{showunder?'收起':'更多'}}
		                    </button>
		                </div>
		            </div>
		            <div class="col-sm-12">
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">试卷状态</label>
		                        <div class="col-sm-8">
		                            <select name="pc" v-model="model.sjzt" class="form-control"
		                                    v-validate="{required:true,max:50}" data-vv-as="试卷状态">
		                                <option value="">-请选择-</option>
		                                <option value="ZCKY">正常可用</option>
		                                <option value="BKY">不可用</option>
		                            </select>
		                        </div>
		                    </div>
		                </div>
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">试题排序</label>
		                        <div class="col-sm-8">
		                            <select name="stpl" v-model="model.stplsx" class="form-control"
		                                    v-validate="{required:true,max:50}" data-vv-as="试题排列顺序">
		                                <option value="">-请选择-</option>
		                                <option v-for="item in stplsxList" :key="item.value" :value="item.value">
		                                    {{item.text}}
		                                </option>
		                            </select>
		                        </div>
		                    </div>
		                </div>
		            </div>
		            <div class="col-sm-12">
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">开启摄像</label>
		                        <div class="col-sm-8">
		                            <select name="kqsx" v-model="model.sfkqsxt" class="form-control"
		                                    v-validate="{required:true,max:50}" data-vv-as="">
		                                <option value="">-请选择-</option>
		                                <option value="1">是</option>
		                                <option value="0">否</option>
		                            </select>
		                        </div>
		                    </div>
		                </div>
		                <!--验证码-->
		                <div class="col-sm-5">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">考试验证码</label>
		                        <div class="col-sm-8">
		                            <input type="text" v-model="model.ksyzm" class="form-control">
		                        </div>
		                    </div>
		                </div>
		                <div class="col-sm-2">
		                    <button class="yzmbtn " @click="randomYzm()" type="button" style="float: right">随机生成</button>
		                </div>
		
		            </div>
		            <div class="col-sm-12">
		                <!--隐藏设置抓拍间隔时间-->
		                <div class="col-sm-5" v-if="showZpjgsj">
		                    <div class="form-group">
		                        <label class="col-sm-4 control-label">抓拍间隔时间</label>
		                        <div class="col-sm-8">
		                            <input type="text" v-model="model.zpjgsj" class="form-control" placeholder="秒">
		                        </div>
		                    </div>
		                </div>
		            </div>
		
		            <!--以下可藏-->
		            <div v-if="showunder">
		                <div class="col-sm-12">
		                    <div class="col-sm-5">
		                        <div class="form-group">
		                            <label class="col-sm-4 control-label">成绩公布</label>
		                            <div class="col-sm-8">
										<DateTimePicker v-model="model.cjgbsj" format="YYYY-MM-DD HH:mm" input-class="form-control" style="width:210px" :show-buttons="true" clearable></DateTimePicker>
		                            </div>
		                        </div>
		                    </div>
		                    <div class="col-sm-5">
		                        <div class="form-group">
		                            <label class="col-sm-4 control-label">考试时长</label>
		                            <div class="col-sm-8">
		                                <input type="text" v-model="model.kssc" class="form-control">
		                            </div>
		                        </div>
		                    </div>
		                    <div class="col-sm-2">
		                        <span style="font-size: 12px">（分钟）</span>
		                    </div>
		                </div>
		                <div class="col-sm-12">
		                    <div class="col-sm-5">
		                        <div class="form-group">
		                            <label class="col-sm-4 control-label">公布答案</label>
		                            <div class="col-sm-8">
		                                <select name="stpl" v-model="model.sfxsda" class="form-control">
		                                    <option value="">-请选择-</option>
		                                    <option value="1">是</option>
		                                    <option value="0">否</option>
		                                </select>
		                            </div>
		                        </div>
		                    </div>
		                    <div class="col-sm-5">
		                        <div class="form-group">
		                            <label class="col-sm-4 control-label">允许手机</label>
		                            <div class="col-sm-8">
		                                <select name="yxsj" v-model="model.sfyxsj" class="form-control">
		                                    <option value="">-请选择-</option>
		                                    <option value="1">是</option>
		                                    <option value="0">否</option>
		                                </select>
		                            </div>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </form>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-primary" type="button" @click="save()">保存</button>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 试卷列表克隆试卷
     */
    export default {
        name: 'ExamPaperPlsz',
        components: {
        },
        data: function () {
            return {
                showZpjgsj: false, //选中开启摄像头   需填写间隔时间
                showunder: false,
                stplsxList: [],
                model: {
                    ids: '',
                    kksj: '',
                    jssj: '',
                    sjzt: '',
                    sfkqsxt: '',
                    zpjgsj: '',
                    stplsx: '',
                    cjgbsj: '',
                    kssc: '',
                    sfxsda: '',
                    sfyxsj: '',
                    ksyzm: '',//考试验证码
                }
            }
        },
        watch: {
            'model.sfkqsxt': function () {
                if (this.model.sfkqsxt == 1) {
                    this.showZpjgsj = true
                } else {
                    this.showZpjgsj = false
                }
            }
        },

        methods: {
			reset:function(){
				this.howZpjgsj = false; //选中开启摄像头   需填写间隔时间
				this.showunder =  false;
				this.stplsxList = [];
				this.model = {
				    ids: '',
				    kksj: '',
				    jssj: '',
				    sjzt: '',
				    sfkqsxt: '',
				    zpjgsj: '',
				    stplsx: '',
				    cjgbsj: '',
				    kssc: '',
				    sfxsda: '',
				    sfyxsj: '',
				    ksyzm: '',//考试验证码
				}
			},
			open:function(params){
				this.model.ids = params.ids;
				this.stplsxList = [{value: 'ZC', text: '正常'}, {value: 'SJ', text: '随机'}];//试题排列顺序
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
			changeflag: function () {
			    this.showunder = !this.showunder
			},
            randomYzm: function () {
                let randomNum = Math.floor(Math.random() * (9999 - 1000)) + 1000;
                this.model.ksyzm = randomNum.toString();
            },
            save: function () {
                this.$http.post('/htgl/biz/zypx/sj/zhcy/plszsx', this.model).then(res => {
                    if (res.data == true) {
                        this.$success('操作成功', () => {
							this.close();
                            this.$parent.load();//刷新列表
                        });
                    }
                })
            }
        }
    }
</script>